import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { convertArrayToString, customTextColor } from "../../utils/const";
import { CircularProgress, Pagination, Typography } from "@mui/material";
import JobCard from "./JobCard";
import { useEffect, useState } from "react";
import { getPostRequirement } from "../../redux/post-requirement/postRequirementSlice";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/system";
import { allLocation } from "../../redux/common/locationSlice";
import { allSkill } from "../../redux/common/skillSlice";
import { getAllMassmailHistory } from "../../redux/massmail/massmailSlice";
import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";

function JobListDrawer({ handleClose, show, handleShowJob, setJObID }) {
  const postRequirement = useSelector((state) => state.postrequirement);
  const locations = useSelector((state) => state.location);
  const skillData = useSelector((state) => state.skill.data);
  const workautho = useSelector((state) => state.workautho);

  const requirementLoading = useSelector(
    (state) => state.postrequirement.status
  );
  const massmailStatus = useSelector((state) => state.massmail.status);

  const [page, setPages] = useState(postRequirement?.data?.current_page || 1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    has_next: false,
    has_previous: false,
    next_page: null,
    previous_page: null,
    total_pages: 1,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPostRequirement(`page=${page}`));
  }, [page]);

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allSkill());
    dispatch(allWorkAuthorization());
  }, [dispatch]);

  useEffect(() => {
    if (postRequirement?.data) {
      setPagination({
        current_page: postRequirement?.data?.current_page,
        has_next: postRequirement?.data?.has_next,
        has_previous: postRequirement?.data?.has_previous,
        next_page: postRequirement?.data?.next_page,
        previous_page: postRequirement?.data?.previous_page,
        total_pages: postRequirement?.data?.total_pages,
      });
    }
  }, [postRequirement?.data]);

  const handlePageChange = (event, value) => {
    setPages(value);
  };

  const getWorkAuthorization = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          workautho?.data?.work_authorization_data?.find(
            (location) => location.id === id
          )?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const getPreferLocationsNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  useEffect(() => {
    if (massmailStatus === "post_massmail_succeeded") {
      handleClose();
      dispatch(getAllMassmailHistory(""));
    }
  }, [massmailStatus]);

  console.log({ postRequirement });

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "500px",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Offcanvas.Title style={{ fontWeight: "600", color: customTextColor }}>
          Active Job List
          <Typography sx={{ marginBottom: "0" }}>
            Fully transparent report will send you
          </Typography>
        </Offcanvas.Title>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body>
        {requirementLoading === "loading" ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 230,
            }}
          >
            <CircularProgress size={30} color="info" />
          </Box>
        ) : postRequirement?.data?.jobs?.length > 0 ? (
          postRequirement?.data?.jobs?.map((requirement) => {
            return (
              <JobCard
                jobId={requirement?.job_id}
                jobTitle={requirement?.job_title}
                experience={requirement?.experience}
                location={
                  requirement?.location !== undefined &&
                  getPreferLocationsNames(requirement?.location)
                }
                visa={
                  requirement?.visa !== undefined &&
                  getWorkAuthorization(requirement?.visa)
                }
                rate={requirement?.rate}
                date={requirement?.created_at}
                requirement={requirement}
                handleShowJob={handleShowJob}
                setJObID={setJObID}
              />
            );
          })
        ) : (
          <h6 style={{ textAlign: "center" }}>No Requirement Found</h6>
        )}
        <Box
          sx={{
            textAlign: "right",
            marginTop: "20px",
            display: "flex",
            justifyContent: "right",
          }}
        >
          <Pagination
            count={pagination.total_pages}
            page={page}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default JobListDrawer;
